module.exports = __webpack_public_path__ + "img/arrow_works_right.920aa53e.svg";